import { produce } from "immer";
export function filterSuperTokensFromTokenList(tokenList) {
    return tokenList.tokens.reduce((accumulator, tokenInfo) => {
        if (tokenInfo.extensions?.superTokenInfo) {
            return produce(accumulator, (draft) => {
                draft.superTokens.push(tokenInfo);
            });
        }
        else {
            return produce(accumulator, (draft) => {
                draft.underlyingTokens.push(tokenInfo);
            });
        }
    }, { superTokens: [], underlyingTokens: [] });
}
